import React        from "react"
import {NewsLayout} from "sections/News/"
import useNewsData  from "shared/Hooks/News/useNewsData"
import {Images}     from "src/sections/News/NewsLayout/Images";
import {List}       from "src/sections/News/NewsLayout/List";
import {TextBlock}  from "src/sections/News/NewsLayout/TextBlock";
import {NEWS_9}     from "types/News"

const Article = () => {
  const data = useNewsData(NEWS_9);

  return (
    <NewsLayout data={data}>
      <List data={data.lists.first}/>
      <TextBlock data={data.texts.first}/>
      <TextBlock data={data.texts.second}/>
      <TextBlock data={data.texts.third}/>
      <Images data={data.images.first}/>
    </NewsLayout>
  )
}

export default Article;
